import apiConstants from '../constants/apiConstans';

const initialState = {
  name: 'Headline Ad',
  apiPage: {},
  error: {},
  loading: false,
  apiProducts: [],
};

// eslint-disable-next-line default-param-last
export default function apiReducer(state = initialState, action) {
  switch (action.type) {
    case apiConstants.GET_ALL_API_SUCCESS:
      return {
        ...state,
        apiPage: action.payload,
      };
    case apiConstants.GET_ALL_API_FAILURE:
      return {
        ...state,
        apiPage: action.payload,
      };
    case apiConstants.GET_API_PRODUCTS_SUCCESS:
      return {
        ...state,
        apiProducts: action.payload,
      };
    case apiConstants.GET_API_PRODUCTS_FAILURE:
      return {
        ...state,
        apiProducts: [],
      };
    default:
      return state;
  }
};
